import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoadingIndicatorService {
    constructor() {}

    loadingStatus: Subject<{
        loading: boolean;
        reqId: string;
        customId?: string;
    }> = new Subject<{
        loading: boolean;
        reqId: string;
        customId?: string;
    }>();
    loadingStatus$ = this.loadingStatus.asObservable();

    loadingStatusGlobal: Subject<{
        loading: boolean;
    }> = new Subject<{
        loading: boolean;
    }>();
    loadingStatusGlobal$ = this.loadingStatusGlobal.asObservable();

    startLoading(reqId: string, customId?: string) {
        this.loadingStatus.next({ loading: true, reqId, customId });
    }

    stopLoading(reqId: string, customId?: string) {
        this.loadingStatus.next({ loading: false, reqId, customId });
    }

    startGlobalLoading() {
        this.loadingStatusGlobal.next({ loading: true });
    }

    stopGlobalLoading() {
        this.loadingStatusGlobal.next({ loading: false });
    }
}
